export default "__VITE_ASSET__BAk607br__"